import { render, staticRenderFns } from "./editUspSidebar.vue?vue&type=template&id=0684d2fe&scoped=true&"
import script from "./editUspSidebar.vue?vue&type=script&lang=js&"
export * from "./editUspSidebar.vue?vue&type=script&lang=js&"
import style0 from "./editUspSidebar.vue?vue&type=style&index=0&id=0684d2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0684d2fe",
  null
  
)

export default component.exports